import UndoIcon from "@mui/icons-material/Undo";
import RedoIcon from "@mui/icons-material/Redo";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import React from "react";
import {TransitionProps} from "@mui/material/transitions";
import {Slide} from "@mui/material";

type CustomToolbarProps = {
  onUndo: () => void;
  onRedo: () => void;
  openAddImage: () => void;
  isUndoAvailable: boolean
  isRedoAvailable: boolean
};

export const CustomToolbar = ({onUndo, onRedo, openAddImage, isUndoAvailable, isRedoAvailable}: CustomToolbarProps) => (
  <div id="toolbar" style={{position: "sticky", top: 0, zIndex: 10000, backgroundColor: "white"}}>
    <select className="ql-header" defaultValue="">
      <option value="1"/>
      <option value="2"/>
      <option value="3"/>
      <option value=""/>
    </select>
    <button className="ql-bold"/>
    <button className="ql-italic"/>
    <button className="ql-underline"/>
    <button className="ql-blockquote"/>
    <button className="ql-list" value="ordered"/>
    <button className="ql-list" value="bullet"/>
    <button className="ql-indent" value="-1"/>
    <button className="ql-indent" value="+1"/>
    <button className="ql-link"/>
    <button className="ql-clean"/>
    <button disabled={!isUndoAvailable} className="ql-undo" onClick={onUndo}><UndoIcon/></button>
    <button  disabled={!isRedoAvailable} className="ql-redo" onClick={onRedo}><RedoIcon/></button>
    <button onClick={openAddImage}><AddPhotoAlternateIcon/></button>
  </div>
);


export const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="left" ref={ref}  {...props} />;
});